<template>
  <div class="d-flex flex-column h-100">
    <note-content
      class="notepad flex-grow-1 h-100"
      v-model="noteContent"
      @image-added="handleImageAdded"
      @save="handleSave"
      :typeOfEditor="typeOfEditor"
      :editable="editable"
      ref="NoteContent"
    />
    <!-- <div class="bg-light py-2 px-3 border-top">
      <div class="custom-control custom-switch">
        <input
          type="checkbox"
          class="custom-control-input"
          v-model="turnOnShare"
          @change="onShareChange()"
          id="customSwitch1"
        />
        <label class="custom-control-label small pt-1" for="customSwitch1"
          >公开这篇笔记</label
        >
      </div>
    </div> -->
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

import { NoteMixin } from '@/mixins/Note/Note';
import { VideoExerciseMixin } from '@/mixins/NoteQA/VideoExercise';

export default {
  name: 'Note',

  mixins: [NoteMixin, VideoExerciseMixin],

  props: {
    typeOfEditor: {
      type: String,
      default: () => 'EXERCISE_NOTE',
    },

    onNoteSaved: {
      type: Function,
      default: () => null,
    },
  },

  data: () => {
    return {
      //
      share: false,
    };
  },

  computed: {
    ...mapState('Mixins/Note', {
      ms_noteContent: 'noteContent',
    }),

    turnOnShare: {
      get: function () {
        // await this.saveNote();
        return this.share;
      },
      set: function (turnOnShare) {
        this.share = turnOnShare;
        // this.saveNote();
      },
    },
  },

  methods: {
    ...mapActions('Mixins/Note', {
      ma_fetchQuestionNote: 'fetchQuestionNote',
      ma_updateQuestionNote: 'updateQuestionNote',
      ma_fetchBulletNote: 'fetchBulletNote',
      ma_updateBulletNote: 'updateBulletNote',
    }),

    ///
    async fetchNote() {
      if (this.c_isVideoCpnt) {
        await this.ma_fetchBulletNote(this.c_bulletId);
      } else {
        await this.ma_fetchQuestionNote(this.c_Question.questionId);
        //this.share = res.data.data.share;
      }
      return this.ms_noteContent;
    },

    ///
    async updateNote({ video, Q, Question }) {
      if (this.c_isVideoCpnt) {
        //this.onNoteSaved({
        //  content: this.noteContent,
        //});
        await this.ma_updateBulletNote({
          bulletId: video.bulletId,
          content: this.noteContent,
        });
      } else {
        if (this.Question.questionId) {
          this.onNoteSaved({
            Question: Q,
            flag: this.noteContent ? true : false,
          });
        }
        await this.ma_updateQuestionNote({
          questionId: Question.questionId,
          content: this.noteContent,
          groupId: Question.groupId,
          courseId: Question.courseId,
          share: this.share,
        });
      }
    },

    ///
    handleSave({ isSaveImmediately }) {
      if (this.c_isVideoCpnt) {
        this.handleSaveNote({ isSaveImmediately, video: this.video });
      } else {
        this.handleSaveNote({
          isSaveImmediately,
          Q: this.Question,
          Question: this.c_Question,
        });
      }
    },

    ///
    async reset() {
      await this.flushSaveNote();
      if (this.c_isNeedReset) {
        this.fetchNoteAndUpdateEditor();
      }
    },

    //onShareChange() {
    //  this.flushSaveNote();
    //},
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
